import {
  Component,
  forwardRef,
  OnInit
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { Country } from '../../data/country.model';
import countries from 'src/app/common/data/countries';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true
    }
  ]
})
export class CountrySelectComponent
  implements ControlValueAccessor, OnInit {

  countries: Country[] = countries;
  filteredCountries: Country[] = [];

  search = '';
  selectedCountry?: Country;
  isOpen = false;

  onChange: (value: Country | null) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit(): void {
    this.filteredCountries = this.countries;

    // 🇹🇳 Pays par défaut : Tunisie
    const tunisie = this.countries.find(c => c.isoCode === 'TN');
    if (tunisie) {
      this.selectCountry(tunisie);
    }
  }

  /** ControlValueAccessor */
  writeValue(value: Country): void {
    this.selectedCountry = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /** UI logic */
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  filterCountries() {
    const val = this.search.toLowerCase();
    this.filteredCountries = this.countries.filter(c =>
      c.name.toLowerCase().includes(val) ||
      c.dialCode.includes(val)
    );
  }

  selectCountry(country: Country) {
    this.selectedCountry = country;
    this.onChange(country);
    this.isOpen = false;
    this.onTouched();
  }

  /** 🔹 Select all countries */
  selectAll() {
    this.search = '';
    this.filteredCountries = this.countries;
  
    this.selectedCountry={
    name: '',
    dialCode: "+216",
    isoCode: "TN",
    flagUrl: "https://cdn.kcak11.com/CountryFlags/countries/tn.svg",
  };
          this.selectCountry(this.selectedCountry);

  this.isOpen=false

  }
}